module.exports = "/images/cloud-computing.svg?4f2b34a82834080d20c4934f178c3114";


//////////////////
// WEBPACK FOOTER
// ./resources/images/cloud-computing.svg
// module id = jLPx
// module chunks = 0